/**
 * Formats a number with fixed decimal places and strips trailing zeros.
 * e.g. 1.00 -> "1", 1.50 -> "1.5", 1.23 -> "1.23"
 */
export function formatNumber(value: number, decimals = 2): string {
  const s = value.toFixed(decimals)
  return s.replace(/\.?0+$/, "")
}

export function formatPercent(decimal: number, decimals = 0): string {
  return `${(decimal * 100).toFixed(decimals)}%`
}

export function formatPercentTick(decimal: number): string {
  return formatPercent(decimal)
}

export function formatCompactNumber(n: number): string {
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(1)}M`
  }
  if (n >= 1_000) {
    return `${(n / 1_000).toFixed(1)}K`
  }
  return n.toLocaleString()
}
